import axios from "axios";
import { GET_SETTINGS } from "./reducer";
import apiCall from "../../helpers/api";
import { GET_SETTINGS_API_URL } from "../../configs/url";

export const getSettings = () => async (dispatch) => {
  return apiCall({
    method: "POST",
    url: GET_SETTINGS_API_URL,
  })
    .then((res) => {
      return dispatch({
        type: GET_SETTINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
